var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusOptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.75 11.25V3.75H11.25V11.25H3.75V12.75H11.25V20.25H12.75V12.75H20.25V11.25H12.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusOptions);
export default __webpack_public_path__ + "static/media/ic-plus-options.b373982bf44f7336888238a072ce8ddc.svg";
export { ForwardRef as ReactComponent };